import { axiosInstance } from '@src/services/common';

export async function getMetadataTimeRange() {
  const response = await axiosInstance.get<{ time_range: [string, string] }>(
    `/gm/v1/metadata/time_range`,
  );

  return response.data.time_range;
}
